import { createSelector } from 'reselect';
import { playerComparisonSelector } from './simple-selectors';

export const playerSelectionVisibleSelector = createSelector(
    playerComparisonSelector,
    (playerComparison) => playerComparison.modalVisible
);
